import { Button, DialogActions, DialogTitle } from "@mui/material";
import { useState } from "react";
import HoldingName from "./AddHolding/HoldingName";
import usePortfolio from "../hooks/PortfolioProvider";
import { useDialog } from "../libs/dialog/DialogProvider";
import { Transaction } from "../models/Transaction";
import PortAccount from "../models/PortAccount";

export default function SwitchTicker(props:{transaction:Transaction}) {
    const [ticker,setTicker] = useState<string>("")
    const {transaction} = props;
    const {closeDialog} = useDialog()

    const onSwitch = async () => {
        if (!ticker) return;
        await PortAccount.i.switchTicker(transaction, ticker)
        closeDialog()
    }
    return <>
        <DialogTitle>Change Ticker</DialogTitle>
        <div className="content">
            <label className="w700">Current Ticker</label>
            <div>{transaction.holding.id}</div>
            <HoldingName holding={null} transaction={null} ticker={ticker} setTicker={setTicker}/>
        </div>
        <DialogActions>
            <Button onClick={onSwitch}>Switch</Button>
        </DialogActions>
    </>
}